import { api } from 'boot/axios'
import Dialog from 'quasar/src/plugins/Dialog.js';import Notify from 'quasar/src/plugins/Notify.js';

import ActionCreate from 'components/Actions/ActionCreate.vue'

export default {
  namespaced: true,
  state: {
    items: [],
    list: {
      LE: [
        { text: 'Da quando viene acquisito, quanti giorni può rimanere Leads senza passare a PC/CL?', question: 'days' },
        { text: 'Cosa vuoi fare se non si verifica la condizione precedente?', multiple: true, question: 'actions' },
        { text: 'Quanto tempo extra vuoi dare prima di decretare il leads non convertito?', question: 'extra' },
      ],
      LE_Follow: [
        { text: 'Da quando viene acquisito, quanti giorni può rimanere Leads senza passare a PC/CL?', question: 'dtoextra', hide: true },
        { text: 'Quanti giorni massimo possono trascorrere dall\'ultima chiamata prima di ricontattarlo?', question: 'days' },
        { text: 'Cosa vuoi fare se non si verifica la condizione precedente?', multiple: true, question: 'actions' },
        { text: 'Quanto tempo extra vuoi dare prima di decretare il leads non convertito?', question: 'extra' },
      ],
      PC: [
        { text: 'Quanti giorni utili vuoi rendere disponibili per aprire un ordine/prova?', question: 'days' },
        { text: 'Cosa vuoi fare se non si verifica la condizione precedente?', multiple: true, question: 'actions' },
        { text: 'Quanto tempo extra vuoi dare dopo l\'eventuale sollecito?', question: 'extra' },
      ],
      PC_Follow: [
        { text: 'Quanti giorni utili vuoi rendere disponibili per aprire un ordine/prova?', question: 'dtoextra', hide: true },
        { text: 'Quanti giorni massimo possono trascorrere dall\'ultima visita prima di ricontattarlo?', question: 'days' },
        { text: 'Cosa vuoi fare se non si verificano le condizioni precedenti?', multiple: true, question: 'actions' },
        { text: 'Quanto tempo extra vuoi dare dopo l\'eventuale sollecito?', question: 'extra' },
      ],
      PC_ProvaNegativa: [
        { text: 'Dopo quanti giorni devi ricontattare il PC da una prova negativa?', question: 'days' },
        { text: 'Cosa vuoi fare per tentare il recupero dalla prova negativa?', multiple: true, question: 'actions' },
        { text: 'Quanto tempo extra vuoi dare dopo il tentativo di recupero?', question: 'extra' },
      ],
      CL_PostVendita: [
        { text: 'Quanto dura il periodo di gestione iniziale?', question: 'pgi' },
        { text: 'Quante visite deve fare nel periodo iniziale?', label: 'Numero Visite', question: 'visits_count' },
        { text: 'Cosa vuoi fare se non si verificano le condizioni precedenti?', multiple: true, question: 'actions' },
        { text: 'Quanto tempo extra vuoi dare dopo l\'eventuale sollecito?', question: 'extra' },
      ],
      CL_Fidelizzazione: [
        { text: 'Quanto dura il periodo di gestione iniziale?', question: 'pgiextra', hide: true },
        { text: 'Quanti giorni massimo possono trascorrere tra una visita e l\'altra?', question: 'days' },
        { text: 'Cosa vuoi fare se non si verificano le condizioni precedenti?', multiple: true, question: 'actions' },
        { text: 'Quanto tempo extra vuoi dare dopo l\'eventuale sollecito?', question: 'extra' },
      ],
      CL_Rivendita: [
        { text: 'Dopo quanti mesi dall\'ultimo acquisto vuoi che venga preso in considerazione?', label: 'Mesi', question: 'mfo' },
        { text: 'Quanti giorni devono esser trascorsi dall\'ultma visita?', question: 'days' },
        { text: 'Cosa vuoi fare se non si verifica la condizione precedente?', multiple: true, question: 'actions' },
        { text: 'Quanto tempo extra vuoi dare dopo l\'eventuale sollecito?', question: 'extra' },
      ],
    },
    choises: [
      { label: 'Leads (Opportunità)', value: 'LE' },
      { label: 'Leads (Follow)', value: 'LE_Follow' },
      { label: 'Potenziali Clienti (Opportunità)', value: 'PC' },
      { label: 'Potenziali Clienti (Follow)', value: 'PC_Follow' },
      { label: 'PC/CL - Prova Negativa', value: 'PC_ProvaNegativa' },
      { label: 'CL - Post Vendita', value: 'CL_PostVendita' },
      { label: 'CL - Fidelizzazione', value: 'CL_Fidelizzazione' },
      { label: 'CL - Rivendita', value: 'CL_Rivendita' },
    ],
    statuses: [
      { name: 'lavorazione', label: 'In lavorazione' },
      { name: 'convertiti', label: 'Condizione Rispettata' },
      { name: 'sollecitare', label: 'Da Sollecitare' },
      { name: 'convertitiPS', label: 'Condizione Rispettata PS' },
      { name: 'persi', label: 'Persi' },
    ],
  },
  getters: {
    findAction: ({ items }) => itemId => items.find(({ id }) => itemId === id),
    findChoise: ({ choises }) => choise => choises.find(({ value }) => choise === value),
    findQuestionText: ({ list }) => (key, search) => list[key].find(({ question }) => question === search),
    findStatus: ({ statuses }) => status => statuses.find(({ name }) => name === status),
    statuses: ({ statuses }) => target => {
      if (target === 'CL_Fidelizzazione') return statuses.filter(({ name }) => name !== 'convertitiPS')
      if (target.endsWith('_Follow') || target === 'CL_Rivendita') return statuses.filter(({ name }) => !['lavorazione', 'convertitiPS'].includes(name))
      return statuses
    },

    activeItems: ({ items }) => items.filter(({ enabled }) => enabled),
    availableChoises: ({ choises }, { activeItems, hasPgi, hasPc, hasLe }) => choises
      .filter(({ value }) => activeItems.findIndex(({ target }) => target === value) === -1)
      .map(choise => {
        let disable = false
        if (choise.value === 'CL_Fidelizzazione') disable = !hasPgi
        if (choise.value === 'PC_Follow') disable = !hasPc
        if (choise.value === 'LE_Follow') disable = !hasLe
        return {
          ...choise,
          disable,
        }
      }),

    hasLe: (_, { activeItems }) => activeItems.findIndex(({ target }) => target === 'LE') !== -1,
    hasPc: (_, { activeItems }) => activeItems.findIndex(({ target }) => target === 'PC') !== -1,
    hasPgi: (_, { activeItems }) => activeItems.findIndex(({ target }) => target === 'CL_PostVendita') !== -1,
  },
  actions: {
    createAction({ getters: { availableChoises: items }, dispatch }, model) {
      if (!model) {
        Dialog.create({
          title: 'CREA PROCESSO',
          message: 'Qual è il target di nominativi?',
          options: {
            type: 'radio',
            model,
            items,
          },
          cancel: true,
          color: 'blue',
        }).onOk(choise => { if (choise) dispatch('storeAction', choise) })
      } else dispatch('storeAction', model)
    },

    storeAction({ commit, state: { list }, getters: { findChoise } }, choise) {
      Dialog.create({ component: ActionCreate, choise: findChoise(choise), questions: list[choise].filter(({ hide }) => !hide) })
        .onOk(async ({ target, results }) => {
          const options = results.reduce((res, { value, question }) => {
            res[question] = value
            return res
          }, {})
          const { data } = await api.post('actions', { target, options })
          commit('ADD_ITEM', data)
          Notify.create({ message: 'Processo creato correttamente', color: 'info', icon: 'mdi-check', position: 'bottom-left' })
        })
    },

    // toggleEnabledAction ({ commit, getters: { findAction, availableChoises } }, itemId) {
    //   let { enabled, target } = findAction(itemId), updates

    //   if (enabled) updates = { enabled: false }
    //   else if (availableChoises.map(({ value }) => value).includes(target)) updates = { enabled: true }

    //   if (!updates) Notify.create({ message: `Esiste già un processo per <i>${target}</i>`, html: true, color: 'red', position: 'bottom-left' })
    //   else {
    //     api.put(`actions/${itemId}`, updates)
    //       .then(() => { commit('UPDATE_ITEM', { itemId, updates }) })
    //       .then(() => { Notify.create({ message: `Processo ${updates.enabled ? 'abilitato' : 'disabilitato'}`, color: 'info', position: 'bottom-left' }) })
    //   }
    // },

    async checkDisable({ dispatch, getters: { findAction, findChoise, activeItems } }, itemId) {
      const others = {
        CL_PostVendita: 'CL_Fidelizzazione',
        PC: 'PC_Follow',
        LE: 'LE_Follow',
      }
      const { target } = findAction(itemId)
      const { label } = findChoise(target)
      const otherTarget = others[target]
      const otherActive = activeItems.find(item => item.target === otherTarget)
      if (otherTarget && otherActive) {
        const { label: otherLabel } = findChoise(otherTarget)
        const message = `Disabilitando questo processo verrà disabilitato anche il processo <b>${otherLabel}</b><br/>Vuoi continuare?<br/><br/><i class="text-caption">Questa operazione è irreversibile</i>`
        return new Promise((resolve, reject) => {
          Dialog.create({ html: true, color: 'blue-grey', title: `Disabilita "${label}"`, message, ok: 'Si', cancel: true })
            .onOk(() => {
              dispatch('disableAction', otherActive.id)
              dispatch('disableAction', itemId)
              resolve()
            })
            .onCancel(() => { reject() })
        })
      } else {
        return new Promise((resolve, reject) => {
          Dialog.create({ html: true, color: 'blue-grey', title: `Disabilita "${label}"`, message: 'Sei sicuro di voler disabilitare questo processo?<br/><br/><i class="text-caption">Questa operazione è irreversibile</i>', ok: 'Si', cancel: true })
            .onOk(() => {
              dispatch('disableAction', itemId)
              resolve()
            })
            .onCancel(() => { reject() })
        })
      }
    },

    async disableAction({ commit }, itemId) {
      const { data: { end_at: endAt } } = await api.put(`actions/disable/${itemId}`)
      commit('UPDATE_ITEM', { itemId, updates: { enabled: false, endAt } })
      // .then(() => { Notify.create({ message: 'Processo disabilitato', color: 'info', position: 'bottom-left' }) })
    },

    async updateNote({ commit }, { itemId, note }) {
      await api.put(`actions/${itemId}`, { note })
      commit('UPDATE_NOTE', { itemId, note })
    },

    showOptions({ getters: { findAction, findQuestionText } }, itemId) {
      // eslint-disable-next-line prefer-const
      let { options, target } = findAction(itemId)
      options = Object.entries(options)
        .map(([question, value]) => `<li>${findQuestionText(target, question).text}<span class="float-right text-bold">${value}</span></li>`)
        .join('')
        .replace('false', 'No')
        .replace('true', 'Si')
      Dialog.create({
        html: true,
        color: 'blue-grey',
        title: 'PARAMETRI',
        message: `<ul style="list-style: none;padding-left: 10px;" class="q-gutter-y-md">${options}</ul>`,
        ok: 'chiudi',
      })
    },

    // destroyAction ({ commit }, itemId) {
    //   Dialog.create({ message: 'Sei sicuro di voler eliminare questo processo?', cancel: true }).onOk(() => {
    //     api.delete('actions/' + itemId).then(() => {
    //       commit('REMOVE_ITEM', itemId)
    //       Notify.create({ message: 'Processo eliminato', color: 'red', icon: 'mdi-delete' })
    //     })
    //   })
    // },

    async fetchItems({ state, commit }) {
      if (state.items.length === 0) {
        const { data } = await api.get('actions')
        commit('SET_ITEMS', data)
      }
    },

    clear: async ({ commit }) => commit('SET_ITEMS', []),
  },
  mutations: {
    SET_ITEMS(state, items) {
      state.items = items
    },
    ADD_ITEM(state, item) {
      state.items.push(item)
    },
    UPDATE_NOTE(state, { itemId, note }) {
      const index = state.items.findIndex(({ id }) => itemId === id)
      state.items[index].note = note
    },
    UPDATE_ITEM(state, { itemId, updates: { enabled, endAt } }) {
      const index = state.items.findIndex(({ id }) => itemId === id)
      state.items[index].enabled = enabled
      state.items[index].end_at = endAt
    },
    REMOVE_ITEM(state, itemId) {
      const index = state.items.findIndex(({ id }) => itemId === id)
      state.items.splice(index, 1)
    },
  },
}
